/* global $ */
var Proj = (function(proj){
    'use strict';

    // Какое то дерьмо которое нагородило то ли Юля Малкова, то ли остальные

    var $allblack = $('.allblack'),
        $allblackmob = $('.allblack_mob');

    proj.Shit = {
        ProdFotorama: function(){
            var $prod = $('.production');
            /* ППО - наше производство */
            $('.js-show-fotorama').click(function() {
                var $this = $(this);
                toggleFotorama();
            });

            /* ППО - открыть/закрыть наше производство */
            function toggleFotorama() {
                if (!$prod.hasClass('m--hidden')) {
                    $prod.addClass('m--hidden');
                }
                else {
                    $prod.removeClass('m--hidden');
                }
            }
        },
        selectColor: function() {
            /* выбор цвета из каталога*/
            $('body').on('click', '.js-select_color', function() {
                var $this = $(this);
                var $containerFull =  $this.parents('.color_cat__full');
                var $container =  $containerFull.find('.color_cat__full__items'); //ППО контейнер цветов всплывающего окна
                var cHeight = $container.innerHeight();
                    $this.parents('.color_cat__full').css('min-height', cHeight + 'px');

                if ($this.hasClass('m--clone')) {
                    $this.animate({height: "0px"}, 300, function () {
                        $container.css('position', '');
                        $this.remove();
                    });
                }
                else {
                    $this.clone().addClass('m--clone').addClass('m--large').appendTo( $containerFull);
                    $container.css('position', 'absolute');
                    if ( cHeight < 300 ) {
                        $containerFull.find('.m--clone').animate({height: "300px"}, 300);
                    }
                    else {
                        $containerFull.find('.m--clone').animate({height: cHeight + "px"}, 300);
                    }

                }
            });
        },
        /* ППО - каталог цветов */
        showColorCatPopup: function() {
            $('.js-color_cat').click(function(event){
                var $this = $(this);
                if ( $this.parent().find('.color_cat__popup').length > 0) {
                    $this.parent().find('.color_cat__popup').fadeIn(300);
                    $allblack.fadeIn(300);
                    $allblackmob.fadeIn(300);
                }
                event.preventDefault();
            });
        },
        /*слайдер на странице товара*/
        prodSliderInit: function() {
            var $prodSlider = $('.prod_page__gallery__moving_part'); //слайдер на странице товара (большой)
            var $prodSmSlider = $('.prod_page__gallery__small__moving_part'); //слайдер на странице товара (большой)

            if ($prodSlider.length>0 && $prodSmSlider.length>0) {
                $prodSlider.slick({
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 300,
                    dots:true,
                    asNavFor: '.prod_page__gallery__small__moving_part',
                });

                $prodSmSlider.slick({
                    arrows: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    speed: 300,
                    asNavFor: '.prod_page__gallery__moving_part',
                    focusOnSelect: true,
                });

                $prodSlider.find('.slick-dots').appendTo( $('.prod_page__gallery__small__container')) ;

                $('.prod_page__gallery__controls.m--left').click(function() {
                    $prodSlider.slick('slickPrev');
                });

                $('.prod_page__gallery__controls.m--right').click(function() {
                    $prodSlider.slick('slickNext');
                });
            }
        },
        greatSpagetti: function(){
            // Великое непонятное спагетти

            $('.js-need-popup').addClass('popup popup--text');

            // $('.list_advantages__descr').addClass('hidden');

            $('.js-more-adv').click(function(event) {
                var $this = $(this);
                $('.list_advantages__descr').css('display','none');

                if ( $('body').find('.header__mobile').css('display') == 'none' && $this.find('.list_advantages__descr__inner').length > 0 && $this.find('.list_advantages__descr__inner').html() != '') {
                    $this.find('.list_advantages__descr').fadeIn(300);
                    $allblack.fadeIn(300);
                    $allblackmob.fadeIn(300);
                }

                if ( $this.parents('.steps__textblock').length > 0) {
                    $this.parents('.steps__textblock').find('.list_advantages__descr').fadeIn(300);
                    $allblack.fadeIn(300);
                    $allblackmob.fadeIn(300);
                }

                event.stopPropagation();
            });

            $('.list_advantages__descr .js-close_popup').click(function(event){
                $('.list_advantages__descr').css('display','none');
                event.stopPropagation();
            });

            /* НВФ - увеличение картинки */
            $('.js-show_calc_img').click(function(event) {
                var $this = $(this);

                $('.list_advantages__descr').css('display','none');
                if ( $this.parent().find('.list_advantages__descr').length > 0) {
                    $this.parent().find('.list_advantages__descr').fadeIn(300);
                    $allblack.fadeIn(300);
                    $allblackmob.fadeIn(300);
                }
                event.stopPropagation();
            });

            var more_speed = 300;

            /* cooperation_block кнопка "подробнее" */
            $('.js-coop_more').click(function(){
                var $this = $(this);
                var $coop_text = $this.parents('.cooperation__item').find('.cooperation__short_text');
                var $coop_more_text = $this.parents('.cooperation__item').find('.cooperation__text');

                if (!$coop_text.hasClass('m--opened')) {
                    //$coop_text.addClass('m--opened'); //убрать фиксированную высоту
                    $this.html('Скрыть');
                    $coop_text.addClass('m--opened')
                    $coop_more_text.animate({height:'toggle'}, more_speed);
                }
                else {
                    if ( $coop_text.hasClass('m--opened')) {
                    //  $coop_text.removeClass('m--opened'); //вернуть фиксированную высоту
                        $this.html('Подробнее');
                        $coop_text.removeClass('m--opened')
                        $coop_more_text.animate({height:'toggle'}, more_speed);
                    }
                }
            });

            var $prodDescr = $('.prod_page__more_hidden'); //подробное описание товара (страница товара)

            /*подробное описание товара*/
            $('body').on('click', '.js--prod_page_more', function() {
                $(this).hide();
                $prodDescr.animate({height:'toggle'},300);
            });
            $prodDescr.animate({height:'toggle'},1);

            var $coop = $('.cooperation');
            if ($coop) {
                $('.cooperation__text').animate({height:'toggle'},1);
            }


            var proj_num = 7; // начальное кол-во проектов на странице
            /* Наши проекты - спрятать проекты*/
            function hideProjects() {
                $('.projects__items.m--all_proj').find('.projects__item').each(function(index) {
                    if (index+1 > proj_num) {
                        $(this).addClass('m--hidden');
                    }
                });
            }

            if ( $('.projects__items.m--all_proj').find('.projects__item').length > 0) {
                hideProjects();
            }




        },
        greatestSpagetti: function(){
            var resizeTimer;

            var is_mob = 0,
                is_mob_big = 0,
                slider_active = 0,
                point_fl = 0, //флаг изменения положения top_point элементов
                $BmobCheck = $('.js-is_big_mobile'), // блок для проверки разрешения (от 1000 до 780 px)
                $mobHead = $('body').find('.header__mobile'),
                $head = $('body').find('.header_top'), //шапка
                $headMid = $head.find('.header__middle'),
                $headWrap = $head.find('.wrapper_m'),
                $mobContacts = $head.find('.header__mobile--contacts'),
                $mobMenu = $head.find('.header__mobile--menu'),
                $mobContBtn = $('.js-open-mobile-contacts'),
                $mobMenuBtn = $('.js-open-mobile-menu'),
                $home_mobMenu = $('.page--home_page').find('.mobile_menu_wrapper'),
                $topMenu = $head.find('.js-open_topmenu'),  // кнопка меню в средней части шапки
                $closeTopMenu =  $head.find('.js-close_topmenu'), // кнопка 'закрыть меню'' в средней части шапки
                $HeadNav = $headMid.find('.header__topmenu'), //nav в шапке
                $HeadCat =  $headMid.find('.header__catalog'),  //кнопка каталога в шапке
                $HeadSlog =  $headMid.find('.header__slogan'),   //слоган в шапке
                $callMe = $('.js-call'), //кнопка 'перезвоните мне'
                $deliveryQ = $('.js-delivery'), //кнопка 'перезвоните мне'
                $popupForm = $('.popup_form_window'),
                $comfSlider = $('.comfortable__items__frame').find('.comfortable__items__moving_part'),
                $revSlider = $('.js-reviews-slider'),
                $lAdvSlider = $('.list_advantages__items'),
                $empSlider = $('.employees__moving_part'),
                $teamSlider = $('.team__gallery'),
                $prodAdvSlider = $('.prod_advantages__items'),
                $servAdvSlider = $('.service_advantages__items'),
                $coopSlider = $('.cooperation__items'),
                $pointPic = $('.main_page_top_img'),
                $catMenu = $('.floating_ancors'),
                $prodInfo = $('.prod_page__content__descr'), //описание на стр. товара
                $prodTab = $('.prod_page__content__table'), //характеристики на стр. товара
                $prodInfoL = $('.prod_page__more_block__inner'), //подробное описание на стр. товара
                $servGroup = $('.page--services_group').find('.services_group'),
                $projGroup = $('.projects_groups'); //верхнее меню проектов

            var $allblack = $('.allblack'),
                $allblackmob = $('.allblack_mob');


            function topPoints() {
                if ( point_fl == 0  && is_mob_big == 1 ) {
                    point_fl = 1;
                    $pointPic.find('.top__point').each(function() {
                        var $this = $(this);
                        var topVal = parseInt($this.css('top')) - 130;
                        $this.css('top', topVal);
                    });
                } else {
                    if ( point_fl == 1  && is_mob_big == 0 ) {
                        point_fl = 0;
                        $pointPic.find('.top__point').each(function() {
                            var $this = $(this);
                            var topVal = parseInt($this.css('top')) + 130;
                            $this.css('top', topVal);
                        });
                    }
                }
            }

            function catMenuCol() {
                $catMenu.find('.floating_ancors__item').each(function(index, el) {
                    var $this = $(this);
                    var targetOffset = $(this.hash).offset(),
                        itemOffset = $this.offset(),
                        targetH = $(this.hash).outerHeight();
                        /*
                        if ( itemOffset.top >= targetOffset.top && itemOffset.top <= targetOffset.top + targetH) {
                            if (!$this.hasClass('m--vis')) {
                                $this.addClass('m--vis');
                            }
                        } else {
                            $this.removeClass('m--vis');
                        }
                        */
                    if ( targetOffset.top + targetH/2 >= $(window).scrollTop() && targetOffset.top <= $(window).scrollTop() + $(window).height() - targetH/2) {
                        if (!$this.hasClass('m--vis')) {
                            $this.addClass('m--vis');
                        }
                    } else {
                        $this.removeClass('m--vis');
                    }
                });
            }
        /*перенос точек*/
            function sliderDots() {
                $('.slick-dots').each(function(index, el) {
                    if ($(this).find('div').length == 0) {
                        var slLen = $('.slick-dots').find('li').length;
                        if (slLen > 12) {
                            $('.slick-dots').find('li').each(function(index, el) {
                                if (index == 7 ) { // parseInt(slLen/2)
                                    $(this).after('<div></div>');
                                }
                            });
                        }
                    }
                });
            }

        /* убрать содержимое popup*/
            function clearPopUp() {
                $popupForm.find('.form_header').hide();
                $popupForm.find('.contact_form').html('');
            }

            function closePopup() {
                $allblackmob.fadeOut(300);
                $allblack.fadeOut(300);
                $('.popup').fadeOut(300);
            }

            function checkForSliders() {
                if ($revSlider.length > 0) {
                    if ($('body').find('.header__mobile').css('display') != 'none') {
                        $revSlider.slick('slickSetOption', 'slidesToShow', 1, true);
                    } else {
                        if ($('.js-is_big_mobile').css('display') != 'none') {
                            $revSlider.slick('slickSetOption', 'slidesToShow', 2, true);
                        } else {
                            $revSlider.slick('slickSetOption', 'slidesToShow', 4, true);
                        }
                    }
                }
            }

            /*открытие/закрытие типов проектов*/
            function ProjFilterClose() {
                $projGroup.fadeOut(300);
                $allblackmob.fadeOut(300);
                $allblack.fadeOut(300);
            }

            function ProjFilterOpen() {
                $projGroup.fadeIn(300);
                $allblackmob.fadeIn(300);
                $allblack.fadeIn(300);
            }

            /*функции открытия/закрытия контактов и меню (мобильных)*/
            function mobContOpen()  {
                if (!$mobContBtn.hasClass('opened')) {
                    $mobContacts.removeClass('m--mobile_closed');
                    $mobContBtn.addClass('opened');
                    $allblack.show();
                    $allblackmob.show();
                    $headWrap.removeClass('hidden');
                }
            }

            function mobContClose()  {
                if ($mobContBtn.hasClass('opened')) {
                    $mobContacts.addClass('m--mobile_closed');
                    $mobContBtn.removeClass('opened');
                    $allblack.hide();
                    $allblackmob.hide();
                    $headWrap.addClass('hidden');
                }
            }

            function mobMenuOpen()  {
                if (!$mobMenuBtn.hasClass('opened')) {
                    $mobMenu.removeClass('hidden');
                    $mobMenuBtn.addClass('opened');
                    $allblackmob.show();
                    $allblack.show();
                    $headWrap.removeClass('hidden');
                }
            }

            function mobMenuClose()  {
                if ($mobMenuBtn.hasClass('opened')) {
                    $mobMenu.addClass('hidden');
                    $mobMenuBtn.removeClass('opened');
                    $allblackmob.hide();
                    $allblack.hide();
                    $headWrap.addClass('hidden');
                }
            }

            function resetBMob() {
                $closeTopMenu.css('display','none');
                $topMenu.removeClass('hidden');
                $HeadCat.removeClass('hidden');
                $HeadSlog.removeClass('hidden');
                $headMid.find('.header__left').css('width','');
                $headMid.find('.header__right').css('width','');
            }

            function closeFormPopup() {
                $popupForm.fadeOut(300);
                $allblackmob.fadeOut(300);
                $allblack.fadeOut(300);
            }

        /* Слайдер "преимущества НВФ" */
            function lAdvSliderInit() {
                if ($lAdvSlider.length>0) {
                    $lAdvSlider.slick({
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        speed: 300,
                        dots:true,
                        // autoplay: true,
                        // autoplaySpeed: 5000,
                    });

                    $('.list_advantages__controls.m--left').click(function() {
                        $lAdvSlider.slick('slickPrev');
                    });

                    $('.list_advantages__controls.m--right').click(function() {
                        $lAdvSlider.slick('slickNext');
                    });
                }
            }
            function lAdvSliderDestr() {
                if ($lAdvSlider.length>0) {
                    $lAdvSlider.slick('unslick');
                }
            }
        /* Слайдер "почему с нами удобно работать" */
            function comSliderInit() {
                if ($comfSlider.length>0) {
                    $comfSlider.slick({
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        speed: 300,
                        // autoplay: true,
                        // autoplaySpeed: 5000,
                    });

                    $('.comfortable__items').find('.comfortable__items__controls.m--left').click(function() {
                        $comfSlider.slick('slickPrev');
                    });

                    $('.comfortable__items').find('.comfortable__items__controls.m--right').click(function() {
                        $comfSlider.slick('slickNext');
                    });
                }
            }
            function comSliderDestr() {
                if ($comfSlider.length>0) {
                    $comfSlider.slick('unslick');
                }
            }
        /* Слайдер "почему с нами удобно работать" для ППО */
            function servAdvSliderInit() {
                if ($servAdvSlider.length>0) {
                    $servAdvSlider.slick({
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        speed: 300,
                        // autoplay: true,
                        // autoplaySpeed: 5000,
                    });

                    $('.service_advantages__controls.m--left').click(function() {
                        $servAdvSlider.slick('slickPrev');
                    });

                    $('.service_advantages__controls.m--right').click(function() {
                        $servAdvSlider.slick('slickNext');
                    });
                }
            }
            function servAdvSliderDestr() {
                if ( $servAdvSlider.length>0) {
                    $servAdvSlider.slick('unslick');
                }
            }
        /* Слайдер "наша компания в лицах" */
            function empSliderInit() {
                if ($empSlider.length>0) {
                    $empSlider.slick({
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        speed: 300,
                        dots:true,
                        // autoplay: true,
                        // autoplaySpeed: 5000,
                    });

                    $('.employees__items').find('.employees__items__controls.m--left').click(function() {
                        $empSlider.slick('slickPrev');
                    });

                    $('.employees__items').find('.employees__items__controls.m--right').click(function() {
                        $empSlider.slick('slickNext');
                    });
                }
            }
            function empSliderDestr() {
                if ($empSlider.length>0) {
                    $empSlider.slick('unslick');
                }
            }

        /* Слайдер "наша команда" */
            function teamSliderInit() {
                if ($teamSlider.length>0) {
                    $teamSlider.slick({
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        speed: 300,
                        dots: true,
                        // autoplay: true,
                        // autoplaySpeed: 5000,
                    });

                    $('.team__controls.m--left').click(function() {
                        $teamSlider.slick('slickPrev');
                    });

                    $('.team__controls.m--right').click(function() {
                        $teamSlider.slick('slickNext');
                    });

                    $teamSlider.find('.slick-dots').appendTo('.team__title');
                }
            }
            function teamSliderDestr() {
                if ($teamSlider.length>0) {
                    $teamSlider.slick('unslick');
                }
            }
        /* Слайдер "преимущества металлокассет" */
            function prodAdvSliderInit() {
                if ($prodAdvSlider.length>0) {
                    $prodAdvSlider.slick({
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        speed: 300,
                        dots: true,
                        fade: true,
                        swipe: false,
                        // autoplay: true,
                        // autoplaySpeed: 5000,
                    });

                    //$prodAdvSlider.find('.slick-dots');
                }
            }
            function prodAdvSliderDestr() {
                if ($prodAdvSlider.length>0) {
                    $prodAdvSlider.slick('unslick');
                }
            }
        /* Слайдер "давайте сотрудничать" */
            function coopSliderInit() {
                if ($coopSlider.length>0) {
                    $coopSlider.slick({
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        speed: 300,
                        dots: true,
                        fade: true,
                        swipe: false,
                        // autoplay: true,
                        // autoplaySpeed: 5000,
                    });
                    //$prodAdvSlider.find('.slick-dots');
                }
            }
            function coopSliderDestr() {
                if ($coopSlider.length>0) {
                    $coopSlider.slick('unslick');
                }
            }
        /* Слайдер "отзывы клиентов" */
            function revSliderInit() {
                if ($revSlider.length>0) {
                    $revSlider.slick({
                        dots: false,
                        arrows: true,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        speed: 300,
                     // autoplay: true,
                     // autoplaySpeed: 5000,
                    });
                }
            }

            function revSliderDestr() {
                if ($revSlider.length>0) {
                    $revSlider.slick('unslick');
                }
            }

            /*Преобразование меню в мобильное и обратно*/
            function mobileTransform()  {
                if ( $mobHead.css('display') != 'none' && is_mob == 0) {
                    is_mob = 1;
                    if (!$mobMenu.hasClass('hidden')) {
                        $mobMenu.addClass('hidden');
                    }
                    if (!$headWrap.hasClass('hidden')) {
                        $headWrap.addClass('hidden');
                    }
                    if ($home_mobMenu) {
                        $head.find('.header__slogan').clone().appendTo($home_mobMenu);
                        $head.find('.header__bottom').clone().appendTo($home_mobMenu);
                    }
                    comSliderInit();
                    empSliderInit();
                    teamSliderDestr();
                    teamSliderInit();
                    lAdvSliderInit();
                    if (slider_active == 0) {
                        prodAdvSliderInit();
                        coopSliderInit();
                        slider_active = 1;
                    }
                    servAdvSliderInit();
                    checkForSliders();
                    ProjFilterClose();
                    $('.page--contacts').find('.m--map_block').appendTo('body');
                    $('.page--contacts').find('.contacts__map').show();
                    $('.about__content_right').addClass('hidden').animate({height:'toggle'},1);
                    $('.service_intro__long').addClass('hidden').animate({height:'toggle'},1);
                    if ($servGroup.length > 0) {
                        $servGroup.find('.services_group__content').addClass('hidden').animate({height:'toggle'},1);
                    }
                    if ($coopSlider.length > 0) {
                        $coopSlider.find('.cooperation__item').each(function() {
                            var $this = $(this);
                            $this.find('.cooperation__name').prependTo( $this.find('.cooperation__block') );
                        });
                    }
                    $('.prod_page').find('.prod_page__calc').after($('.prod_page').find('h1'));
                    $('.prod_page').find('.prod_page__buttons').appendTo($('.prod_page').find('.prod_page__left'));
                    $prodInfoL.appendTo($prodInfo);

                    $prodTab.addClass('m--back_tab');

                    $head.removeClass('m--moving');
                    $mobContacts.removeClass('m--moving');
                    $headMid.removeClass('m--moving');

                    $('.js-calculate-max').find('.calculators__square').each(function(index, el) {
                        $(this).prependTo($(this).parents('.js-calculate-max').find('.calculators__form'));
                    });
                } else {
                    if ( $mobHead.css('display') == 'none' && is_mob == 1) {
                        is_mob = 0;
                        mobContClose();
                        mobMenuClose();
                        if ($mobMenu.hasClass('hidden')) {
                            $mobMenu.removeClass('hidden');
                        }
                        if (!$headWrap.hasClass('hidden')) {
                            $headWrap.removeClass('hidden');
                        }
                        if ($home_mobMenu) {
                            $home_mobMenu.html('');
                        }
                        comSliderDestr();
                        empSliderDestr();
                        teamSliderDestr();
                        lAdvSliderDestr();
                        /*
                        if (slider_active == 1) {
                            prodAdvSliderDestr();
                            coopSliderDestr();
                            slider_active = 0;
                        }
                        */
                        servAdvSliderDestr();
                        checkForSliders();
                        $allblack.hide();
                        $allblackmob.hide();
                        $projGroup.css('display', '');

                        $('.page--contacts').find('.m--contacts_block').after($('.page--contacts').find('.m--map_block'));

                        if ( $('.about__content_right').hasClass('hidden') ) {
                            $('.about__content_right').removeClass('hidden').animate({height:'toggle'},1);
                        }
                        if ( $('.service_intro__long').hasClass('hidden') ) {
                            $('.service_intro__long').removeClass('hidden').animate({height:'toggle'},1);
                        }
                        $('.js-more_text').css('display','');
                        $('.catalog').find('.js-cat-more').show();
                        $('.catalog').find('.cat_mob_more').css('display', '');
                        if ($servGroup.length > 0) {
                            $servGroup.find('.services_group__content').each(function() {
                                if ($(this).hasClass('hidden')) {
                                    $(this).removeClass('hidden').animate({height:'toggle'},1);
                                }
                            });
                            $('.services_group__item').find('.services_group__content__more').css('display','');
                        }
                        /*
                        if ($coopSlider.length > 0) {
                            $coopSlider.find('.cooperation__item').each(function() {
                                $this = $(this);
                                $this.find('.cooperation__name').appendTo($this.find('.cooperation__numblock'));
                            });
                        }
                        */
                        $('.prod_page').find('h1').prependTo($('.prod_page').find('.prod_page__right'));
                        $('.prod_page').find('.prod_page__buttons').appendTo($('.prod_page').find('.prod_page__right'));
                        $prodInfoL.appendTo($('.prod_page__more_block'));
                        $('.prod_page__tab_content').removeClass('m--back_tab');

                        $('.js-calculate-max').find('.calculators__params').each(function(index, el) {
                            $(this).prependTo($(this).parents('.js-calculate-max').find('.calculators__form'));
                        });
                    }
                }
                if (is_mob == 0 && is_mob_big == 0 ) {
                    if (slider_active == 1) {
                        prodAdvSliderDestr();
                        coopSliderDestr();
                        slider_active = 0;
                    }
                    if ($coopSlider.length > 0) {
                        $coopSlider.find('.cooperation__item').each(function() {
                            var $this = $(this);
                            $this.find('.cooperation__name').appendTo($this.find('.cooperation__numblock'));
                        });
                    }
                }
            }

            function mobileTransformBig()  {
                if ( $BmobCheck.css('display') != 'none' && is_mob_big == 0) {
                    is_mob_big = 1;
                    if (!$HeadNav.hasClass('hidden')) {
                        $HeadNav.addClass('hidden');
                    }
                    $head.find('.header__top').clone().appendTo('.mobile_mid_menu');
                    checkForSliders();
                    if (slider_active == 0) {
                        prodAdvSliderInit();
                        coopSliderInit();
                        slider_active = 1;
                    }
                    if ($coopSlider.length > 0) {
                        $coopSlider.find('.cooperation__item').each(function() {
                            var $this = $(this);
                            $this.find('.cooperation__name').prependTo( $this.find('.cooperation__block') );
                        });
                    }
                } else {
                    if ($BmobCheck.css('display') == 'none' && is_mob_big == 1 ) {
                        is_mob_big = 0;
                        $HeadNav.removeClass('hidden');
                        resetBMob();
                        $('.mobile_mid_menu').html('');
                        checkForSliders();
                    }
                }
            }

            /*функция, выполняемая при изменении размеров окна*/
            function resizeFunction() {
                mobileTransform();
                mobileTransformBig();
                topPoints();
                sliderDots();
            }

            revSliderInit();
            mobileTransformBig();
            mobileTransform();
            $popupForm.hide();
            checkForSliders();
            topPoints();
            sliderDots();

            /* кнопка 'перезвоните мне' */
            $('body').on('click', '.js-call', function(event) {
                event.preventDefault();
                mobContClose();
                mobMenuClose();
                clearPopUp();
                $('#form_call').parents('.form_content').find('.form_header').show();

                proj.Feedback({
                    wrap:'#form_call'
                });

                $popupForm.fadeIn(300);
                $allblack.fadeIn(300);
                $allblackmob.fadeIn(300);
            });

            $('body').on('click', '.js-delivery', function(event) {
                event.preventDefault();
                mobContClose();
                mobMenuClose();
                clearPopUp();
                $('#form_delivery').parents('.form_content').find('.form_header').show();

                proj.Feedback({
                    wrap:'#form_delivery'
                });

                $popupForm.fadeIn(300);
                $allblack.fadeIn(300);
                $allblackmob.fadeIn(300);
            });

            $('body').on('click', '.js-request', function(event) {
                event.preventDefault();
                mobContClose();
                mobMenuClose();
                clearPopUp();
                $('#form_request').parents('.form_content').find('.form_header').show();

                proj.Feedback({
                    wrap:'#form_request'
                });

                $popupForm.fadeIn(300);
                $allblack.fadeIn(300);
                $allblackmob.fadeIn(300);
            });

            $('body').on('click', '.js-writeus', function(event) {
                event.preventDefault();
                mobContClose();
                mobMenuClose();
                clearPopUp();
                $('#form_mail').parents('.form_content').find('.form_header').show();

                proj.Feedback({
                    wrap: '#form_mail'
                });

                $popupForm.fadeIn(300);
                $allblack.fadeIn(300);
                $allblackmob.fadeIn(300);
            });

            $('body').on('click', '.js-custom-form', function(e) {
                e.preventDefault();

                var $this = $(this);

                mobContClose();
                mobMenuClose();
                clearPopUp();
                var form_wrap = '#' + $this.data('wrapId');
                var $wrap = $(form_wrap);
                if($wrap.length){

                    $wrap.parents('.form_content').find('.form_header').show();

                    proj.Feedback({
                        wrap: form_wrap
                    });

                    $popupForm.fadeIn(300);
                    $allblack.fadeIn(300);
                    $allblackmob.fadeIn(300);
                }
            });

            $('body').on('click', '.js--get_price', function(event) {
                event.preventDefault();
                var prod_name;
                var button_pressed = $(this);
                clearPopUp();
                $('#form_order').parents('.form_content').find('.form_header').show();

                proj.Feedback({
                    wrap:'#form_order'
                });

                $popupForm.fadeIn(300);
                $('.waiting_block').animate({height:'toggle'}, 500, function() {
                    if ( button_pressed.parents('tr').find('.prod_page__variants_name').length > 0) {
                        prod_name =  button_pressed.parents('tr').find('.prod_page__variants_name').find('a').text();
                        $('#form_order').find('.attr-content').find('textarea').val(prod_name);
                    } else {
                        prod_name = $('h1').text();
                        $('#form_order').find('.attr-content').find('textarea').val(prod_name);
                    }
                });
                $allblack.fadeIn(300);
                $allblackmob.fadeIn(300);
            });

            $('body').on('click', '.js-calc-specification', function() {
                var importText = $(this).parents('.calculators__item').find('.calculators__name').text();
                var button_pressed = $(this);
                clearPopUp();
                $('#form_calc').parents('.form_content').find('.form_header').show();

                proj.Feedback({
                    wrap:'#form_calc'
                });

                $popupForm.fadeIn(300);
                $('.waiting_block').animate({height:'toggle'}, 800, function() {
                    button_pressed.parents('.js-calculate-success').find('.calculators__result').each(function() {
                        importText = importText + $(this).text();
                    });
                    $('#form_calc').find('textarea').val(importText);
                });
                $allblack.fadeIn(300);
                $allblackmob.fadeIn(300);
            });

            $popupForm.find('.js-close_popup').click(function(){
                closeFormPopup();
            });

            /*Мобильное меню: основное меню*/
            $mobMenuBtn.click(function(){
                var $this = $(this);
                if (!$mobMenu.hasClass('hidden')) {
                    mobMenuClose();
                } else {
                    mobContClose();
                    mobMenuOpen();
                }

            });

            /*Мобильное меню: контакты*/
            $mobContBtn.click(function(){
                var $this = $(this);
                if ($mobContacts.hasClass('m--mobile_closed')) {
                    mobMenuClose();
                    mobContOpen();
                } else {
                    mobContClose();
                }
            });

            /* Окно типов проектов*/
            $('.js-proj-filter').click(function(){
                if ($projGroup.css('display') != "none") {
                    ProjFilterClose();
                } else {
                    ProjFilterOpen();
                }
            });

            $('.js-filter_close').click(function(){
                ProjFilterClose();
            });

            $allblack.click(function(){
                mobContClose();
                mobMenuClose();
                ProjFilterClose();
                closeFormPopup();

                $('.calculators__block').each(function(index, el) {
                    var $this = $(this);
                    if ( !$this.hasClass('m--minwidth') ) {
                        $this.addClass('m--minwidth');
                        $this.removeClass('m--fullwidth');
                        $this.find(".js-calculate-min").show();
                        $this.find(".js-calculate-max").hide();
                        $this.find(".js-calculate-success").hide();
                    }
                });
            });

            $allblackmob.click(function(){
                mobContClose();
                mobMenuClose();
                ProjFilterClose();
                closeFormPopup();

                $('.calculators__block').each(function(index, el) {
                    var $this = $(this);
                    if ( !$this.hasClass('m--minwidth') ) {
                        $this.addClass('m--minwidth');
                        $this.removeClass('m--fullwidth');
                        $this.find('.js-calculate-min').show();
                        $this.find('.js-calculate-max').hide();
                        $this.find('.js-calculate-success').hide();
                    }
                });
            });

            $('.js-calculate').click(function(){
                if (is_mob == 1) {
                    $allblackmob.fadeIn(300);
                    $allblack.fadeIn(300);
                }
            });

            /*открыть/закрыть текст о компании*/
            $('.js-more_text').click(function(){
                if ( $('.about__content_right').hasClass('hidden') ) {
                    $('.about__content_right').removeClass('hidden').animate({height:'toggle'},300);
                    $(this).hide();
                }
                if ( $('.service_intro__long').hasClass('hidden') ) {
                    $('.service_intro__long').removeClass('hidden').animate({height:'toggle'},300);
                    $(this).hide();
                }
            });

            $('.js-less_text').click(function(){
                if ( !$('.about__content_right').hasClass('hidden') ) {
                    $('.about__content_right').addClass('hidden').animate({height:'toggle'},300, function() {
                        $('.js-more_text').show();
                    });
                }

                if ( !$('.service_intro__long').hasClass('hidden') ) {
                    $('.service_intro__long').addClass('hidden').animate({height:'toggle'},300, function() {
                        $('.js-more_text').show();
                    });
                }

            });

            /* подробнее о модификации на стр. товара*/
            $('.js--var_show_more').click(function(){
                var $this = $(this);
                var $parent = $this.parents('tr');

                if ($parent.hasClass('opened')) {
                    $this.html('подробнее');
                    $parent.removeClass('opened');
                } else {
                    $this.html('скрыть');
                    $parent.addClass('opened');
                }
            });

            /*листовая сталь: открыть/закрыть описание*/
            $('.js-show_serv').click(function(e){
                if ($servGroup.length > 0 && is_mob == 1) {
                    e.preventDefault();

                    var $this = $(this);
                    var $servText = $this.parents('.services_group__item').find('.services_group__content');
                    if ($servText.hasClass('hidden')) {
                        $this.parents('.services_group__item').find('.services_group__content__more').css('display','none');
                        $servText.removeClass('hidden');
                        $servText.animate({height:'toggle'},200);
                    } else {
                        $servText.addClass('hidden');
                        $servText.animate({height:'toggle'},200, function() {
                            $this.parents('.services_group__item').find('.services_group__content__more').css('display','block');
                        });
                    }
                }
            });

            /*переключение описания/характерисик на стр. товара*/
            $('.js--prod_tab').click(function(){
                var $this = $(this);
                var $parent = $this.parents('.prod_page__tab_content');
                if ( $parent.hasClass('m--back_tab') ) {
                    $parent.removeClass('m--back_tab');
                    $parent.siblings('.prod_page__tab_content').addClass('m--back_tab')
                }
            });

            var $headPhoneMoving = $('.js-phone-moving'),
                $headCallMoving = $('.js-call-moving');

            /*Малое меню: панель навигации*/
            $topMenu.click(function(){
                var $this = $(this);
                if ($HeadNav.hasClass('hidden')) {

                    $HeadNav.removeClass('hidden');
                }
                $this.addClass('hidden');
                $HeadCat.addClass('hidden');
                $HeadSlog.addClass('hidden');
                $headPhoneMoving.addClass('hidden');
                $headCallMoving.addClass('hidden');
                $headMid.find('.header__left').css('width','auto');
                $headMid.find('.header__right').css('width','auto');
                $closeTopMenu.css('display','block');
            });

            $closeTopMenu.click(function(){
                var $this = $(this);
                if (!$HeadNav.hasClass('hidden')) {
                    $HeadNav.addClass('hidden');
                }
                $headPhoneMoving.removeClass('hidden');
                $headCallMoving.removeClass('hidden');
                resetBMob();
            });

            $allblack.click(function(){
                closePopup();
            });

            $allblackmob.click(function(){
                closePopup();
            });

            $('.js-close_popup').click(function(){
                closePopup();
            });

            /*якоря каталога*/
            $catMenu.find('a').click(function(event){
                event.preventDefault();
                var scr = $(this.hash).offset();
                $('html, body').animate({
                    scrollTop: scr.top - 200
                }, 500);
            });

            /*шапка двигается при прокрутке*/
            var lastScrollTop = 0;

            $(window).scroll(function() { 
                if (is_mob == 0) {
                    var newScrollTop = $(window).scrollTop();
                    if ($(window).scrollTop()>400){
                        $head.addClass('m--moving');
                        $mobContacts.addClass('m--moving');
                        $headMid.addClass('m--moving');
                        /*if (newScrollTop > lastScrollTop){               // downscroll code
                            if (!$mobContacts.hasClass('m--hide')) {
                                $mobContacts.addClass('m--hide');
                            }
                            if (!$headMid.hasClass('m--hide')) {
                                $headMid.addClass('m--hide');
                            }
                        } else {                                        // upscroll code
                            $mobContacts.removeClass('m--hide');
                            $headMid.removeClass('m--hide');
                        }*/
                    } else {
                        $head.removeClass('m--moving');
                        $mobContacts.removeClass('m--moving');
                        $headMid.removeClass('m--moving');
                    }
                    lastScrollTop = newScrollTop;
                } else {
                    if ($('.page--prod_cat').length > 0) {
                        if ($(window).scrollTop()>100){
                            $catMenu.addClass('m--moving');
                            $('h1').addClass('m--moving');
                        } else {
                            $catMenu.removeClass('m--moving');
                            $('h1').removeClass('m--moving');
                        }
                    }
                }

                catMenuCol();

            });

            $( window ).resize(function() {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(resizeFunction, 250);
                if($mobHead.css('display') == 'none'){
                    $('.page--contacts').find('.contacts__map').hide();
                }
            });

            if (location.hash !== '') {
                var $el = $(location.hash);
                if ($el.length) {
                    var headHeight = is_mob ? $mobHead.outerHeight() : $mobContacts.outerHeight();
                    var scrollTop = $el.offset().top - parseInt($el.css('margin-top')) - headHeight;
                    $('html, body').scrollTop(scrollTop);
                }
            }
        }
    };

    return proj;
})(Proj || {});



